import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Privacy Policy — summary placeholder. Align with actual data flows (Vapi, hosting, email) and get legal review.
 */
export default function LegalPrivacy() {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-200">
      <div className="max-w-3xl mx-auto px-4 py-12 md:py-16">
        <Link to="/" className="text-cyan-400 hover:text-cyan-300 text-sm mb-8 inline-block">
          ← Back to home
        </Link>
        <h1 className="text-3xl md:text-4xl font-bold text-white mt-4 mb-2">Privacy Policy</h1>
        <p className="text-gray-400 text-sm mb-10">Last updated: March 2026</p>

        <div className="space-y-6 text-sm md:text-base leading-relaxed">
          <p className="text-amber-200/90 bg-amber-900/20 border border-amber-700/40 rounded-lg p-4">
            This policy describes how Appify.AI may collect and use information. Update it to match your real
            processing activities and subprocessors, and have it reviewed by counsel for GDPR/UK GDPR, POPIA, and
            other laws that apply to your customers.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">1. Who we are</h2>
            <p>
              Appify.AI provides voice AI tools and related services. Contact:{' '}
              <a href="mailto:admin@appifyai.com" className="text-cyan-400 hover:underline">
                admin@appifyai.com
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">2. Information we may collect</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Account details you provide (name, email, company).</li>
              <li>Usage and technical data (logs, device/browser type, approximate region).</li>
              <li>
                Voice and call-related data when you use our assistants, which may include call metadata, transcripts,
                or recordings as configured for your workspace.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">3. How we use information</h2>
            <p>
              We use data to provide and improve the service, support you, secure our systems, and comply with law.
              AI features may process prompts and call content to generate responses.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">4. Calls, recordings, and AI</h2>
            <p>
              Depending on your configuration, calls may be recorded or transcribed. You are responsible for providing
              any notices or obtaining any consents required for your callers under applicable law. We may use
              subprocessors (for example voice AI and infrastructure providers) to deliver the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">5. Cookies and similar technologies</h2>
            <p>
              Our marketing site may use cookies or local storage for basic functionality and analytics. You can
              control cookies through your browser settings. Where required, we will align this section with your
              analytics tools and consent banner.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">6. Retention</h2>
            <p>
              We retain information as long as needed to provide the service and meet legal obligations. Retention
              periods may vary by data type and contract.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">7. Your rights</h2>
            <p>
              Depending on where you live, you may have rights to access, correct, delete, or object to certain
              processing. Contact us to make a request. You may also lodge a complaint with a supervisory authority.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">8. Changes</h2>
            <p>We may update this policy from time to time. We will post the updated version on this page.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
